import React, { useState } from 'react';
import useStore from '../../store/useStore';

const TranslationPanel = ({ field, fieldLabel, englishValue, translations, onTranslationChange, showAllLanguages = false }) => {
  const { availableLanguages } = useStore();
  const [showTooltip, setShowTooltip] = useState(null);

  // Filter languages based on showAllLanguages prop
  const displayLanguages = showAllLanguages
    ? availableLanguages
    : availableLanguages.filter(lang => lang.code === 'en');

  const handleTranslationEdit = (langCode, value) => {
    const newTranslations = { ...translations };
    newTranslations[langCode] = value;
    onTranslationChange(field, newTranslations);
  };

  // Ensure we have a fallback for translations
  const safeTranslations = translations || {};

  // Get keyboard shortcut hint based on platform
  const getKeyboardHint = () => {
    const platform = navigator.platform.toLowerCase();
    if (platform.includes('mac')) {
      return 'Press Control+Space (or Fn+E) to switch keyboard';
    } else if (platform.includes('win')) {
      return 'Press Windows+Space to switch keyboard';
    } else {
      return 'Press Super+Space to switch keyboard';
    }
  };

  return (
    <div className="translation-panel" style={{ marginBottom: '20px', border: '1px solid #e0e0e0', borderRadius: '6px', padding: '15px' }}>
      <div style={{ marginBottom: '15px' }}>
        <h4 style={{ margin: 0, color: '#2d5016' }}>{fieldLabel}</h4>
      </div>

      <div className="translation-grid" style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '15px'
      }}>
        {displayLanguages.map(lang => (
          <div key={lang.code} className="translation-field" style={{
            border: 'none',
            borderRadius: '4px',
            padding: '5px 0',
            backgroundColor: lang.code === 'en' ? '#f8fdf8' : 'transparent',
            position: 'relative'
          }}>
            <label style={{
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              fontWeight: '500',
              marginBottom: '8px',
              color: lang.code === 'en' ? '#2d5016' : '#333',
              fontSize: '13px'
            }}>
              <span>{lang.nativeName} ({lang.code.toUpperCase()})</span>
              {lang.code === 'en' && <span style={{ color: '#d32f2f' }}> *</span>}
              {lang.code !== 'en' && (
                <span
                  style={{
                    cursor: 'help',
                    fontSize: '14px',
                    padding: '0 4px',
                    position: 'relative'
                  }}
                  onMouseEnter={() => setShowTooltip(lang.code)}
                  onMouseLeave={() => setShowTooltip(null)}
                  title={getKeyboardHint()}
                >
                  ⌨️
                  {showTooltip === lang.code && (
                    <div style={{
                      position: 'absolute',
                      bottom: '100%',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      backgroundColor: '#333',
                      color: 'white',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      fontSize: '11px',
                      whiteSpace: 'nowrap',
                      zIndex: 1000,
                      marginBottom: '5px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
                    }}>
                      {getKeyboardHint()}
                      <div style={{
                        position: 'absolute',
                        top: '100%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: 0,
                        height: 0,
                        borderLeft: '5px solid transparent',
                        borderRight: '5px solid transparent',
                        borderTop: '5px solid #333'
                      }} />
                    </div>
                  )}
                </span>
              )}
            </label>

            {field.includes('Preparation') || field.includes('Processing') || field.includes('fertilizers') || field.includes('weedControl') || field.includes('irrigation') || field.includes('harvesting') ? (
              <textarea
                value={safeTranslations[lang.code] || ''}
                onChange={(e) => handleTranslationEdit(lang.code, e.target.value)}
                lang={lang.code}
                rows="3"
                style={{
                  width: '100%',
                  resize: 'vertical',
                  fontSize: '14px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  padding: '8px'
                }}
                placeholder={lang.code === 'en' ? `Enter ${fieldLabel.toLowerCase()} in English` : `Type in ${lang.nativeName} (switch keyboard first)`}
              />
            ) : (
              <input
                type="text"
                value={safeTranslations[lang.code] || ''}
                onChange={(e) => handleTranslationEdit(lang.code, e.target.value)}
                lang={lang.code}
                style={{
                  width: '100%',
                  fontSize: '14px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  padding: '8px'
                }}
                placeholder={lang.code === 'en' ? `Enter ${fieldLabel.toLowerCase()} in English` : `Type in ${lang.nativeName} (switch keyboard first)`}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TranslationPanel;